import { init, setUser as setSentryUser } from '@sentry/browser';

import { SENTRY_DENIED_URLS, SENTRY_IGNORED_ERRORS } from '@cuemath/leap';
import { getUserIdFromCookie } from '@~/utils/auth';

import { IS_DEV, IS_STAGING, SENTRY_DSN } from '../../constants/app-config';

const userId = getUserIdFromCookie();

function canTrackErrors() {
  return !IS_DEV;
}

function setUser(id: string | null) {
  if (canTrackErrors()) {
    setSentryUser(
      id
        ? {
            id,
          }
        : null,
    );
  }
}

function initSentry() {
  if (canTrackErrors()) {
    const envName = IS_STAGING ? 'staging' : 'production';

    init({
      dsn: SENTRY_DSN,
      denyUrls: SENTRY_DENIED_URLS,
      ignoreErrors: SENTRY_IGNORED_ERRORS,
      release: `${envName}:${process.env.REACT_APP_SENTRY_RELEASE}`,
      environment: envName,
      initialScope: userId
        ? {
            user: {
              id: userId,
            },
          }
        : undefined,
      tracesSampleRate: 1,
      tracesSampler: () => 0,
      beforeBreadcrumb(breadcrumb) {
        if (
          breadcrumb.category === 'xhr' &&
          breadcrumb.data?.url?.contains('/presence/sub-key/')
        ) {
          return null;
        }

        return breadcrumb;
      },
    });
  }
}

initSentry();

export { setUser };
